export { default } from './SideBarMenuRenderer'
